import React from "react";
import styled from "styled-components";

import { NodeEvent } from "../../generated/graphql";
import { LinkButton } from "../shared/Button";
import Icon from "../shared/Icon";
import Text from "../shared/Text";
import ParagraphWrapper, { ParagraphType } from "./ParagraphWrapper";
import EventDateLocation from "./EventDateLocation";

interface RelatedEventProps {
  event: NodeEvent;
}

const RelatedEvent: React.FC<RelatedEventProps> = props => {
  const { event } = props;
  return (
    <Wrapper>
      <EventHeader>
        <EventTitle>
          <Icon icon="event" fillColor="darkGreen" />
          <EventDetails>
            <Text as="h3">{event.title}</Text>
            <EventDateLocation event={event} />
          </EventDetails>
        </EventTitle>
        {event.fieldSiteLink?.uri && (
          <HeaderLink>
            <LinkButton
              small={true}
              target="_blank"
              href={event.fieldSiteLink.uri}
            >
              {event.fieldSiteLink?.title || "More Info"}
            </LinkButton>
          </HeaderLink>
        )}
      </EventHeader>
      <ParagraphWrapper pageContent={event.fieldContent as ParagraphType} />
    </Wrapper>
  );
};

const EventHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.midGreyAlt};
  padding-top: 3rem;
  &:last-child {
    border-bottom: none;
    padding-top: 0;
  }
`;

const EventDetails = styled.div`
  padding-left: 1rem;
`;
const EventTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderLink = styled.div`
  margin-left: auto;
`;

export default RelatedEvent;
